// plan-18 S01: question normalization — bible §45 determinism contract

export function normalize(q: string): string {
  return q
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/[.!?;]+$/, '')
}

export interface QuestionStats {
  len: number
  words: number
  digits: number
  firstWord: string
}

export function qStats(normalized: string): QuestionStats {
  if (!normalized) {
    return { len: 0, words: 0, digits: 0, firstWord: '' }
  }
  const words = normalized.split(' ')
  const firstWord = (words[0] || '').replace(/[.!?;:,]+$/, '')
  let digits = 0
  for (let i = 0; i < normalized.length; i++) {
    if (normalized[i] >= '0' && normalized[i] <= '9') digits++
  }
  return {
    len: normalized.length,
    words: words.length,
    digits,
    firstWord,
  }
}
